import Icon, { IconName } from "Components/Icons/Icon";
import React, { useEffect, useRef } from "react";
import CountUp from "react-countup";

interface StatsOverviewProps {
  title: string;
  value: number;
  iconName: IconName;
  iconBg?: string;
  className?: string;
  prefix: string;
  suffix: string;
  separator?: string;
  decimal?: number;
  onClick?: () => void;
}

const StatsOverview: React.FC<StatsOverviewProps> = ({
  title,
  value,
  iconName,
  iconBg = "#466FF61A",
  className = "",
  prefix,
  suffix,
  separator,
  decimal,
  onClick,
}) => {
  const prevValueRef = useRef(value);

  useEffect(() => {
    prevValueRef.current = value;
  }, [value]);
  return (
    <div
      className={`bg-white p-3 shadow-sm d-flex justify-content-between align-items-center br-10 ${className} ${
        onClick && "cursor-pointer"
      }`}
      onClick={onClick}
    >
      <div className="flex-column flex-fill">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>
            <p className="text-grey89 fw-medium fs-12 font-primary">{title}</p>
          </div>
          <div
            className="d-flex justify-content-center align-items-center br-48"
            style={{
              width: 48,
              height: 48,
              backgroundColor: iconBg,
            }}
          >
            <Icon name={iconName} />
          </div>
        </div>
        <p className="text-black1C fw-bold fs-24 font-primary pb-0 mb-0">
          <CountUp
            start={prevValueRef.current}
            prefix={prefix}
            suffix={suffix}
            separator={separator || ""}
            end={value}
            decimals={decimal}
            duration={2}
          />
        </p>
      </div>
    </div>
  );
};

export default React.memo(StatsOverview);
